/* ── SmartPack Core - carousel ── */
(function () {
	'use strict';

	var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	var SMALL = window.matchMedia && window.matchMedia('(max-width: 990px)').matches;

	var DESIGN = !!(window.Shopify && window.Shopify.designMode);

	var DRAG_PX = 12;

	function Carousel(root) {
		this.root = root;
		this.track = root.querySelector('[data-track]');
		if (!this.track) return;
		this.slides = Array.prototype.slice.call(this.track.querySelectorAll('[data-slide]'));
		if (this.slides.length < 2) { this.retire(); return; }

		this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
		this.prev = root.querySelector('[data-prev]');
		this.next = root.querySelector('[data-next]');

		this.interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;
		this.wantsAuto = root.getAttribute('data-autoplay') === 'true' && !REDUCED && (!SMALL || DESIGN);
		this.surrendered = false;		this.paused = false;
		this.index = 0;
		this.raf = null;
		this.startedAt = 0;
		this.elapsed = 0;

		this.bind();
		this.sync();
		if (this.wantsAuto) this.play();
	}

	Carousel.prototype.retire = function () {
		var junk = this.root.querySelectorAll('[data-prev],[data-next],[data-dots]');
		for (var i = 0; i < junk.length; i++) junk[i].hidden = true;
	};

	Carousel.prototype.bind = function () {
		var self = this;

		if (this.prev) this.prev.addEventListener('click', function () { self.restart(); self.go(self.index - 1); });
		if (this.next) this.next.addEventListener('click', function () { self.restart(); self.go(self.index + 1); });

		this.dots.forEach(function (dot, i) {
			dot.addEventListener('click', function () { self.restart(); self.go(i); });
		});

		this.root.addEventListener('focusin', function (e) {
			var t = e.target;
			if (t && t.matches && t.matches(':focus-visible')) self.pause();
		});
		this.root.addEventListener('focusout', function (e) {
			if (!self.root.contains(e.relatedTarget)) self.resume();
		});

		this.root.addEventListener('keydown', function (e) {
			if (e.key === 'ArrowLeft') { self.restart(); self.go(self.index - 1); e.preventDefault(); }
			if (e.key === 'ArrowRight') { self.restart(); self.go(self.index + 1); e.preventDefault(); }
		});

		var settle;
		this.track.addEventListener('scroll', function () {
			clearTimeout(settle);
			settle = setTimeout(function () { self.readIndex(); self.sync(); }, 90);
		}, { passive: true });

		var downX = null;
		this.track.addEventListener('pointerdown', function (e) { downX = e.clientX; }, { passive: true });
		this.track.addEventListener('pointermove', function (e) {
			if (downX === null) return;
			if (Math.abs(e.clientX - downX) > DRAG_PX) { downX = null; self.restart(); }
		}, { passive: true });
		this.track.addEventListener('pointerup', function () { downX = null; }, { passive: true });
		this.track.addEventListener('pointercancel', function () { downX = null; }, { passive: true });

		window.addEventListener('resize', function () { self.sync(); });
	};

	Carousel.prototype.readIndex = function () {
		var x = this.track.scrollLeft, best = 0, bestGap = Infinity;
		for (var i = 0; i < this.slides.length; i++) {
			var gap = Math.abs(this.slides[i].offsetLeft - this.track.offsetLeft - x);
			if (gap < bestGap) { bestGap = gap; best = i; }
		}
		this.index = best;
	};

	Carousel.prototype.go = function (i) {
		var last = this.lastIndex();
		if (i < 0) i = last;
		if (i > last) i = 0;
		this.index = i;
		this.track.scrollTo({
			left: this.slides[i].offsetLeft - this.track.offsetLeft,
			behavior: REDUCED ? 'auto' : 'smooth'
		});
		this.sync();
		this.restart();
	};

	Carousel.prototype.lastIndex = function () {
		var max = this.track.scrollWidth - this.track.clientWidth - 2;
		for (var i = 0; i < this.slides.length; i++) {
			if (this.slides[i].offsetLeft - this.track.offsetLeft >= max) return i;
		}
		return this.slides.length - 1;
	};

	Carousel.prototype.sync = function () {
		var last = this.lastIndex();
		this.dots.forEach(function (dot, i) {
			var on = i === this.index;
			dot.classList.toggle('is-active', on);
			dot.setAttribute('aria-current', on ? 'true' : 'false');
		}, this);
		this.root.classList.toggle('is-at-start', this.index <= 0);
		this.root.classList.toggle('is-at-end', this.index >= last);
	};

	Carousel.prototype.surrender = function () {
		if (DESIGN) { this.restart(); return; }
		this.surrendered = true;
		this.stop();
	};

	Carousel.prototype.play = function () {
		if (this.surrendered || !this.wantsAuto) return;
		this.root.classList.add('is-playing');
		this.startedAt = performance.now() - this.elapsed;
		this.tick();
	};

	Carousel.prototype.tick = function () {
		var self = this;
		this.raf = requestAnimationFrame(function (now) {
			if (self.paused || self.surrendered) return;
			self.elapsed = now - self.startedAt;
			var pct = Math.min(self.elapsed / self.interval, 1);
			self.root.style.setProperty('--sp-flip-progress', (pct * 100) + '%');
			if (pct >= 1) { self.elapsed = 0; self.startedAt = now; self.advance(); }
			self.tick();
		});
	};

	Carousel.prototype.advance = function () {
		var i = this.index + 1;
		if (i > this.lastIndex()) i = 0;
		this.index = i;
		this.track.scrollTo({
			left: this.slides[i].offsetLeft - this.track.offsetLeft,
			behavior: REDUCED ? 'auto' : 'smooth'
		});
		this.sync();
	};

	Carousel.prototype.restart = function () {
		if (this.surrendered || !this.wantsAuto) return;
		this.elapsed = 0;
		this.startedAt = performance.now();
	};

	Carousel.prototype.pause = function () { this.paused = true; this.elapsed = performance.now() - this.startedAt; };

	Carousel.prototype.resume = function () {
		if (this.surrendered || !this.wantsAuto || !this.paused) return;
		this.paused = false;
		this.startedAt = performance.now() - this.elapsed;
		this.tick();
	};

	Carousel.prototype.stop = function () {
		if (this.raf) cancelAnimationFrame(this.raf);
		this.raf = null;
		this.root.classList.remove('is-playing');
		this.root.style.removeProperty('--sp-flip-progress');
	};

	function init(scope) {
		var nodes = (scope || document).querySelectorAll('[data-sp-carousel]');
		for (var i = 0; i < nodes.length; i++) {
			if (nodes[i].__spCarousel) continue;
			nodes[i].__spCarousel = new Carousel(nodes[i]);
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { init(); });
	} else {
		init();
	}

	document.addEventListener('shopify:section:load', function (e) { init(e.target); });

	window.SPCore = window.SPCore || {};
	window.SPCore.carousel = { init: init };
})();
